<template>
  <div>
    <service-work-form :refresh-works="refreshWorks" />
    <b-card
      no-body
    >
      <b-card-header>
        <b-card-title>Günlük Çalışma Notları</b-card-title>
      </b-card-header>
      <app-collapse
        v-if="dataList.length > 0"
        accordion
      >
        <app-collapse-item
          v-for="(dataItem,index) in dataList"
          :key="dataItem.id"
          :is-visible="index === 0"
          :title="moment(dataItem.wdate).format('DD.MM.YYYY')"
        >
          <work-item :data-item="dataItem" />
        </app-collapse-item>
      </app-collapse>
      <b-card-body v-else>
        <b-alert
          show
          variant="warning"
        >
          <div class="alert-body text-center">
            <div>
              <FeatherIcon icon="InfoIcon" />
            </div>
            <div>
              Henüz hiç çalışma notu eklenmemiş.
            </div>
          </div>
        </b-alert>
      </b-card-body>
    </b-card>
  </div>
</template>
<script>
import {
  BCard, BCardHeader, BCardTitle, BAlert, BCardBody,
} from 'bootstrap-vue'
import AppCollapse from '@core/components/app-collapse/AppCollapse.vue'
import AppCollapseItem from '@core/components/app-collapse/AppCollapseItem.vue'
import ServiceWorkForm from '@/views/Services/View/ServiceWorkForm.vue'
import WorkItem from '@/views/Services/View/ServiceWorks/WorkItem.vue'

export default {
  name: 'ServiceWorks',
  components: {
    BCard,
    BCardHeader,
    BCardTitle,
    BAlert,
    BCardBody,
    AppCollapseItem,
    ServiceWorkForm,
    WorkItem,
    AppCollapse,
  },
  props: {
    refreshWorks: {
      type: Function,
      required: true,
    },
  },
  computed: {
    dataList() {
      return this.$store.getters['serviceWorks/dataList']
    },
  },
}
</script>
